<template>
  <div>
    <div class="is-flex is-align-items-center">
      <router-link class="button is-info" :to="{ name: 'admin-question-infos', query: { question_id: payload.data.id } }">Question Infos</router-link>
      <div class="horizontal_space"></div>
      <router-link class="button is-info" :to="{ name: 'admin-question-options', query: { question_id: payload.data.id } }">Question Options</router-link>
    </div>
    <div v-if="form">
      <div>
        <p><b>Designator</b></p>
        <input class="outlined" v-model="form.data.question.fields.designator.value">
      </div>
      <div>
        <p>Applicant Success Condition</p>
        <select class="outlined" dir="rtl" v-model="form.data.question.fields.applicant_success_condition.value">
          <option>one_common</option>
          <option>exact</option>
          <option>applicant_included</option>
          <option>position_included</option>
          <option>both_true</option>
          <option>custom</option>
          <option>lte</option>
          <option>gte</option>
          <option>gt</option>
        </select>
      </div>
      <div>
        <p><b>Importance</b></p>
        <input class="outlined" v-model="form.data.question.fields.importance.value">
      </div>
    </div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  props: ['payload'],
  name: 'admin-questions-infos-form',
  data () {
    return {
      is_loading: false,
      form: undefined
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils.getAdminQuestion({ id: this.payload.data.id }).then(response => {
        this.setForm(response)
      })
    },
    setForm (form_data) {
      this.form = new this.$form({
        question: {
          fields: {
            designator: {
              value: form_data.designator,
              has_error: false,
              validations: []
            },
            applicant_success_condition: {
              value: form_data.applicant_success_condition,
              has_error: false,
              validations: []
            },
            importance: {
              value: form_data.importance,
              has_error: false,
              validations: []
            },
            id: {
              value: form_data.id,
              has_error: false,
              validations: []
            }
          },
          request_details: {
            method: this.payload.is_create ? 'post' : 'put',
            url: '/questions/' + form_data.id,
            headers: 'admin_headers'
          },
          is_used: true
        }
      })
    },
    submit () {
      let response = this.form.mySubmit()
      if (response === false) {
        return
      }
      this.is_loading = true
      response.promise.then((response) => {
        this.is_loading = false
        this.$utils.emit('show_toast', { text: 'success' })
        this.remove(this.payload)
      })
    },
    ...mapMutations('modals', ['remove'])
  }
}
</script>
